<template>
  <layout-admin current="clients">
    <div class="panel">
      <div class="panel__head">
        <h1>Clients</h1>
        <span>{{ clients.length }}</span>
      </div>

      <div v-if="!clients.length" class="panel__empty">No clients yet.</div>

      <div v-else class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Registration</th>
              <th>Projects</th>
              <th>Email</th>
              <th>Active</th>
              <th>Invoices</th>
              <th>Subscriptions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="client in clients" :key="client.id">
              <td>
                <Link :href="clientInvoicesHref(client.id)" class="link">{{ client.name }}</Link>
                <div class="muted wrap">{{ client.address }}</div>
              </td>
              <td class="mono">{{ client.registration || '—' }}</td>
              <td>
                <div v-for="project in client.projects" :key="project.id" class="project">
                  <span class="mono">{{ project.code }}</span>
                  <span class="sep">–</span>
                  <span class="muted">{{ project.domain }}</span>
                </div>
                <div v-if="!client.projects.length" class="muted">—</div>
              </td>
              <td>{{ client.billing_email }}</td>
              <td>
                <span class="pill" :class="client.active ? 'is-on' : 'is-off'">
                  {{ client.active ? 'Yes' : 'No' }}
                </span>
              </td>
              <td>
                <Link :href="clientInvoicesHref(client.id)" class="link">{{ client.invoice_count }}</Link>
              </td>
              <td>{{ client.subscription_count }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </layout-admin>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';
import LayoutAdmin from '@/Layouts/Admin.vue';

export default {
  components: {
    LayoutAdmin,
    Link
  },

  props: {
    clients: { type: Array, required: true }
  },

  methods: {
    clientInvoicesHref(clientId) {
      return this.route('admin.invoices.index', { client: clientId });
    }
  }
};
</script>
